// extracted by mini-css-extract-plugin
export var companyImages = "styles-module--companyImages--94f88";